import { getPagePaginationList } from "@/shared/utilities";
import ArrowLeftSmallIcon from "@/assets/icons/arrow-left-small.svg";
import ArrowRightSmallIcon from "@/assets/icons/arrow-right-small.svg";
import { twMerge } from "tailwind-merge";
import Link from "next/link";

export interface Props {
  itemsCount: number;
  currentPage: number;
  itemsPerPage: number;
  baseUrl?: string;
  className?: string;
}

const Pagination = ({
  itemsCount,
  currentPage,
  itemsPerPage,
  baseUrl,
  className,
}: Props) => {
  const isFirstPage = currentPage == 1;
  const isLastPage = currentPage == Math.ceil(itemsCount / itemsPerPage);

  return (
    <div
      className={twMerge(
        "flex items-center justify-center md:justify-between",
        className,
      )}
    >
      <div className="flex gap-x-8 items-center">
        <div className="flex gap-x-4">
          {isFirstPage ? (
            <span
              className={
                "w-[40px] h-[40px] flex items-center justify-center rounded-lg"
              }
            >
              <ArrowLeftSmallIcon className={"fill-grey h-[14px]"} />
            </span>
          ) : (
            <Link
              href={`${baseUrl}/${currentPage - 1}`}
              className={
                "w-[40px] h-[40px] flex items-center justify-center rounded-lg"
              }
            >
              <ArrowLeftSmallIcon className={"fill-primary h-[14px]"} />
            </Link>
          )}
          {isLastPage ? (
            <span
              className={
                "w-[40px] h-[40px] flex items-center justify-center rounded-lg"
              }
            >
              <ArrowRightSmallIcon className={"h-[14px] fill-grey"} />
            </span>
          ) : (
            <Link
              href={`${baseUrl}/${currentPage + 1}`}
              className={
                "w-[40px] h-[40px] flex items-center justify-center rounded-lg"
              }
            >
              <ArrowRightSmallIcon className={"fill-primary h-[14px]"} />
            </Link>
          )}
        </div>
        <div className="flex gap-x-6">
          {getPagePaginationList(itemsCount, itemsPerPage, currentPage).map(
            (item, ix) => (
              <div key={ix}>
                {item === "..." ? (
                  <span
                    className={twMerge("font-medium text-sm text-secondary")}
                  >
                    {item}
                  </span>
                ) : (
                  <Link
                    href={`${baseUrl}/${item}`}
                    className={twMerge(
                      "font-medium text-sm text-secondary",
                      item === currentPage && "text-primary",
                    )}
                  >
                    {item}
                  </Link>
                )}
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default Pagination;
